// Imports
import React from 'react';
import styled from 'styled-components/macro';
import helperFunctions from '../../../../shareables/foundation/front-end/utils/helper-functions';
import { GeneratedThemeProps } from '../../../templates/template-style';
import { baseLinkStyle } from '../styled-hyperlinks';


// Styled component
const Wrapper = styled.span<{ theme: GeneratedThemeProps }>`
	${baseLinkStyle}
	color: ${(props) => props.theme.contentLinkColor};
`;


// Define the accepted props
interface Props extends React.PropsWithChildren {
	onClick: () => void;
}


// Function component
const ActionLink: React.FC<Props> = ({ onClick, children }) => (
	<Wrapper {...helperFunctions.buttonize(onClick)}>{children}</Wrapper>
);

export default ActionLink;
